import { render, staticRenderFns } from "./start-analysis-cmp.vue?vue&type=template&id=580f8e58&"
import script from "./start-analysis-cmp.vue?vue&type=script&lang=ts&"
export * from "./start-analysis-cmp.vue?vue&type=script&lang=ts&"
import style0 from "./start-analysis-cmp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports